/** 回饋項目 - 分類選項 */
export enum RewardCategory {
  /** 酬賓機票 */
  FQTR = 'FQTR',
  /** 商務卡 */
  SPEC = 'SPEC',
  /** 哩程兌換券 */
  MEXC = 'MEXC',
  /** 購票優惠碼 */
  BTDC = 'BTDC',
  /** 台灣機票折價券 */
  ATDC = 'ATDC',
  /** 升等券 */
  FQTU = 'FQTU',
  /** 機場禮遇 */
  APPR = 'APPR',
  /** 套裝商品 */
  SUIT = 'SUIT'
}
